import React, { useContext } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
// import { uid } from 'uid';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { OptionTypeBase } from 'react-select';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import Select from '../../../form-controls/Select';
import { getRequiredErrorMessage } from '../../../../utils/common.utils';
import TextInput from '../../../form-controls/TextInput';
// import {
//     getLgaFromGeoData,
//     getAddressComponent,
//     getStationFromGeoData,
//   } from '../../alpha.utils';
import { getLgaFromGeoData, getAddressComponent } from '../../alpha.utils';
import LocationInput from '../../../form-controls/PlacesAutocomplete';
import { PropsFromRedux } from '.';
// import disabledRedImg from '../../../../assets/icons/fadeout-radio.svg';
// import redImg from '../../../../assets/icons/red-round.svg';
import {
  LGA,
  SERVICE_CENTER,
  STATION,
} from '../../../../interfaces/shipping.interface';
import { USER } from '../../../../interfaces/auth.interface';
import AlphaContext from '../../../../context/AlphaContext/AlphaContext';
import { BeatLoader, Spinner } from '../../../Spinners/Spinner';
import { ShipmentContext } from '../../../../context/AlphaContext/AlphaShipmentContext';

interface Props extends PropsFromRedux {
  alphaData: any;
  setAlphaData: Function | any;
}

interface Inputs {
  // FirstName: string;
  // LastName : string;
  FullName: string;
  PhoneNumber: string;
  Email: string;
  Address: string;
  DestinationState: string | any;
  RecieverState: any;
  PickupCenter: SERVICE_CENTER;
}

const schema = yup.object().shape({
  FullName: yup.string().required(getRequiredErrorMessage('FullName')),
  // LastName: yup
  //   .string()
  //   .required(getRequiredErrorMessage("LastName")),
  PhoneNumber: yup.string().required(getRequiredErrorMessage('PhoneNumber')),
  Email: yup.string().email().required(getRequiredErrorMessage('Email')),
  Address: yup.string(),
  DestinationState: yup.string(),
  ReceiverState: yup.object().shape({
    IsActive: yup.boolean(),
    StationId: yup.number(),
    StationName: yup.string(),
  }),
  PickupCenter: yup.object().shape({
    IsActive: yup.boolean(),
    StationId: yup.number(),
    StationName: yup.string(),
  }),
});

export const UserDetails: React.FC<Props> = ({
  hideModal,
  showModal,
  modal,
  user,
  serviceCenters,
  getServiceCenters,
  getActiveLgas,
  activelgas,
  homeDeliveryLocations,
  locations,
  alphaLoginState,
}) => {
  const history = useHistory();

  const closeModal = () => {
    hideModal();
  };

  const [destination, setDestination] = React.useState<any>();
  const [modalProps, setModalProps] = React.useState<any>();
  const [receiverStation, setReceiverState] = React.useState<any>();
  // const stations: STATION[] = locations?.response?.Object || [];
  const [stations, setStation] = React.useState<any>();
  const [destinationData, setDestinationData] = React.useState<
    google.maps.GeocoderResult[] | null
  >(null);
  const lgas: LGA[] = activelgas?.response?.Object;
  // const centers: SERVICE_CENTER[] = serviceCenters?.response?.Object || [];
  const [centers, setCenters] = React.useState<any>();
  const [isWithinServiceArea, setIsWithinServiceArea] =
    React.useState<boolean>(false);
  const [priceDetails, setPriceDetails] = React.useState<any>();
  const homeDeliveries: LGA[] = homeDeliveryLocations?.response?.Object;
  //   const receiversLga = getLgaFromGeoData(destination, homeDeliveries);
  const userObj: USER = user?.response?.Object;
  const [errorMsg, setErrorMsg] = React.useState('');
  const [userState, setUserState] = React.useState(false);
  const [priceState, setPriceState] = React.useState(false);
  const [stationState, setStationState] = React.useState(true);
  const [error, setError] = React.useState('');
  // const modalData : any = modal?.ownProps?.data;
  

  const { alphaData, setAlphaData } = useContext(AlphaContext);
  const { setShipmentData } = useContext(ShipmentContext);

  const location = useLocation();

  React.useEffect(() => {
    if (!location.pathname.includes('/alpha-product')) {
      setAlphaData(alphaData);
      closeModal();
    }
  }, [alphaData]);

  const goBack = () => {
    showModal({
      component: 'DeliveryMethod',
      modalProps: {
        contentLabel: 'Delivery method',
      },
    });
    setAlphaData(alphaData);
  };

  const ALPHA_SHIPPING_PRICE_PROD = 'https://order.thealphashops.com/api/v1/order/guest/shipping_price'
  const ALPHA_SHIPPING_PRICE_TEST = 'https://dev-order.thealphashops.com/api/v1/order/guest/shipping_price'
  
  const ALPHA_GUEST_NEW_TEST =
    'https://dev-user.thealphashops.com/api/v1/user/guest/new';
  const ALPHA_GUEST_NEW_PROD =
    'https://user.thealphashops.com/api/v1/user/guest/new';

  const onSubmit = async (data: Inputs) => {
    const productData = alphaData;
    let buyerid: any;
    const stationid = parseInt(alphaData.Merchants[0].SenderStationId, 10);

    if (productData.IsHomeDelivery === true) {
      productData.ReceiverLocation = {
        Latitude: `${
          destinationData?.length &&
          destinationData[0]?.geometry?.location?.lat()
        }`,
        Longitude: `${
          destinationData?.length &&
          destinationData[0]?.geometry?.location?.lng()
        }`,
      };

      // added
      productData.SenderLocation = {
        Latitude: `${
          destinationData?.length &&
          destinationData[0]?.geometry?.location?.lat()
        }`,
        Longitude: `${
          destinationData?.length &&
          destinationData[0]?.geometry?.location?.lng()
        }`,
      };

      productData.ReceiverName = data.FullName;
      // productData.ReceiverName = data.FirstName + data.LastName;
      productData.ReceiverPhoneNumber = data.PhoneNumber;
      productData.ReceiverAddress = data.Address;
      productData.ReceiverStationId = receiverStation.StationId;
      productData.ReceiverEmail = data.Email;
      setAlphaData(productData);
    } else if (productData.IsHomeDelivery === false) {
      productData.ReceiverName = data.FullName;
      // productData.ReceiverName = data.FirstName + data.LastName;
      // productData.ReceiverPhoneNumber = data.PhoneNumber;
      // productData.ReceiverEmail = data.Email;
      // productData.ReceiverStationId = receiverStation.StationId;

      productData.ReceiverPhoneNumber = data.PhoneNumber;
      productData.ReceiverEmail = data.Email;
      productData.ReceiverStationId = PickupCenterSelected.StationId;
      productData.ReceiverAddress = PickupCenterSelected.Address;
      productData.SenderStationId = +alphaData.Merchants[0].SenderStationId;
      productData.ReceiverLocation = {
        Latitude: `${PickupCenterSelected.Latitude}`,
        Longitude: `${PickupCenterSelected.Longitude}`,
      };


      setAlphaData(productData);
    }

    const userdata = {
      first_name: data.FullName,
      last_name: data.FullName,
      email: data.Email,
      password: data.FullName,
      phone: data.PhoneNumber,
    };
    setUserState(true);
    console.log('about to call');

    fetch(window.location.hostname === "localhost" ? ALPHA_GUEST_NEW_TEST : ALPHA_GUEST_NEW_PROD, {
      method: 'post',
      headers: new Headers({
        Authorization: `Basic ${alphaLoginState?.response?.results?.token}`,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(userdata),
    })
      .then((res) => res.json())
      .then((result) => {
        setUserState(false);
        /* eslint no-underscore-dangle: 0 */
        const ownerid = result.results._id;
        buyerid = ownerid;
        productData.Merchants[0].PreShipmentItems[0].buyer_id = buyerid;

        setPriceState(true);

        const url =
          window.location.hostname === 'localhost'
            ? ALPHA_SHIPPING_PRICE_TEST
            : ALPHA_SHIPPING_PRICE_PROD;

        const token = alphaLoginState?.response?.results?.token;

        console.log('Token:', token);
        console.log('Request URL:', url);

        fetch(url, {
          method: 'post',
          headers: new Headers({
            Authorization: `Basic ${alphaLoginState?.response?.results?.token}`,
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(productData),
        })
          .then((res) => res.json())
          .then((res) => {
            console.log('Response received:', res);

            setPriceState(false);
            if (res.message === 'Success') {
              setPriceDetails(res.results);

              setShipmentData(res.results);
              // productData.DeliveryPrice = res.results.Object.Merchants[0].GrandTotal;
              // productData.totalCost = res.results.Object.Merchants[0].GrandTotal + productData.Merchants[0].PreShipmentItems[0].shippingFee;
              // productData.ShippingFee = res.results.Object.Merchants[0].PickUpCharge;

              // productData.DeliveryPrice =
              //   res.results.Merchants[0].DeliveryPrice;
              // productData.totalCost = res.results.Merchants[0].GrandTotal;
              // productData.ShippingFee = res.results.Merchants[0].PickUpCharge;
              // productData.totalProductCost =
              //   res.results.Merchants[0].GrandTotal +
              //   productData.Merchants[0].PreShipmentItems[0].shippingFee;

              setAlphaData(productData);
              showModal({
                component: 'PaymentMethod',
                modalProps: {
                  contentLabel: productData,
                },
              });
            } else if (
              res.message === 'Success' &&
              res.results.Code === '404'
            ) {
              setError(res.results.ShortDescription);
              setErrorMsg(res.results.ShortDescription);
            }
          });
      }).catch((err: any) => console.log("error-- ", err))
  };

  React.useEffect(() => {
    async function fetchData() {
      const geocode = await geocodeByPlaceId(destination);
      setDestinationData(geocode);
    }
    if (destination) {
      fetchData();
    }
  }, [destination]);

  React.useEffect(() => {
    if (destinationData) {
      const receiverState: any = getAddressComponent(
        destinationData,
        'administrative_area_level_1'
      )?.long_name;
      const selectedState = receiverState.toUpperCase();

      const stationObj: any = stations.find(
        (station: any) => station.StationName === selectedState
      );
      if (stationObj !== undefined) {
        setReceiverState(stationObj);
      }
      setValue('DestinationState', stationObj.StationName);
    }
  }, [destinationData]);

  React.useEffect(() => {
    if (destinationData) {
      const senderLga: any = getLgaFromGeoData(destinationData, lgas);
      if (!senderLga) {
        setIsWithinServiceArea(false);
      } else {
        setIsWithinServiceArea(true);
      }
    }
  }, [lgas, destinationData]);

  React.useEffect(() => {
    const requestOptions = {
      'content-type': 'application/json',
      method: 'GET',
      //  redirect: 'follow',
      //  mode: 'no-cors'
    };
    setStationState(true);
    const headers = { 'Content-Type': 'application/json' };
    const apiUrl = `https://order.thealphashops.com/api/v1/order/guest/stations`;
    fetch(apiUrl, requestOptions)
      .then((res) => res.json())
      .then((result) => {
        setStationState(false);
        setStation(result.results.Object);
      });
  }, []);

  const { handleSubmit, control, errors, watch, register, setValue } =
    useForm<Inputs>({
      resolver: yupResolver(schema),
      // defaultValues : {
      //     DestinationState: receiverStation?.StationName
      // }
    });
  const SelectedStation: any = watch('ReceiverState');
  const PickupCenterSelected: any = watch('PickupCenter');

  React.useEffect(() => {
    if (SelectedStation?.StationId) {
      const requestOptions = {
        'content-type': 'application/json',
        method: 'GET',
        //  redirect: 'follow',
        //  mode: 'no-cors'
      };
      const headers = { 'Content-Type': 'application/json' };
      const apiUrl = `https://order.thealphashops.com/api/v1/order/guest/service_centers?stationId=${SelectedStation?.StationId}`;
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((result) => {
          setCenters(result.results.Object);
        });
      // getServiceCenters(SelectedStation.StationId);
    }
  }, [SelectedStation?.StationId]);

  if (stationState) {
    return (
      <div className="flex items-center justify-center w-full pt-4 overflow-hidden">
        <Spinner color="#CCC" />
      </div>
    );
  }

  return (
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
      <div className="relative w-full px-6 py-10 bg-white lg:px-20">
        <div className="flex justify-between w-full">
          <Link
            className="-mt-4 font-bold lg:mb-0"
            to={{ pathname: '' }}
            onClick={() => {
              goBack();
            }}
          >
            <HiOutlineArrowNarrowLeft className="inline-flex mt-6 mr-3 text-2xl font-bold" />
          </Link>
          <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky text-2xl cursor-pointer sm:absolute left-full lg:-mt-6 md:-mt-6 sm:left-auto sm:right-5 sm:top-16" />
          </button>
        </div>

        <div className="w-full p-4 text-sm font-medium text-center">
          <p>
            In order for us to deliver this item successfully and timely to you,
            please share the recievers name and address.
          </p>
        </div>
        <div className="flex items-center justify-center w-full my-2 border-b border-gray-300 ">
          <h3 className="pb-4 text-gray-500">Enter Delivery Details</h3>
        </div>
        <div className="flex justify-between w-full my-6 bg-white  ">
          <Controller
            name="FullName"
            control={control}
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="w-full p-2 mr-1 border border-gray-300 rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                label="Full Name"
                type="string"
                wrapperClassName="w-full"
                errorClassName="pt-12 -mt-16  absolute"
                error={errors['FullName']}
                placeholder=""
                customChange={onChange}
              />
            )}
          />
          <Controller
            name="PhoneNumber"
            control={control}
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="w-full p-2 mx-4 ml-1 mr-2 border border-gray-300 rounded"
                id={name}
                labelClassName="mb-2 mr-2 flex text-sm text-gray-500 font-medium"
                label="PhoneNumber"
                type="string"
                wrapperClassName="w-full"
                error={errors['PhoneNumber']}
                errorClassName="absolute -mt-6 "
                placeholder=""
                customChange={onChange}
              />
            )}
          />
        </div>

        {alphaData.IsHomeDelivery == false && (
          <div className="flex justify-between w-full my-6 bg-white">
            <Controller
              name="ReceiverState"
              control={control}
              defaultValue=""
              render={({ name, value, onChange }) => (
                <Select
                  name={name}
                  value={value}
                  id={name}
                  wrapperClassName="w-full"
                  labelKey="StationName"
                  valueKey="StationId"
                  // error={errors['ReceiverState']}
                  label="Destination State"
                  labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                  placeholder=""
                  customChange={onChange}
                  className="my-4 mr-1 rounded-md"
                  options={stations}
                  noOptionsMessage={() => 'Loading...'}
                />
              )}
            />

            {SelectedStation && (
              <Controller
                name="PickupCenter"
                control={control}
                defaultValue=""
                render={({ name, value, onChange }) => (
                  <Select
                    name={name}
                    value={value}
                    id={name}
                    wrapperClassName="w-full"
                    labelKey="FormattedServiceCentreName"
                    valueKey="ServiceCentreId"
                    //   error={errors['PickupCenter']}
                    label="Pickup Center"
                    labelClassName="mb-2 flex ml-2 text-sm text-gray-500 font-medium"
                    placeholder=""
                    customChange={onChange}
                    className="my-4 rounded-md"
                    options={serviceCenters?.loading ? [] : centers}
                    noOptionsMessage={() => 'Loading...'}
                  />
                )}
              />
            )}
          </div>
        )}

        <div className="flex justify-between w-full my-6 bg-white">
          <Controller
            name="Email"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="w-full p-2 mr-1 border border-gray-300 rounded"
                id={name}
                labelClassName="mb-2 flex ml-2 text-sm text-gray-500 font-medium"
                label="Email Address"
                type="string"
                wrapperClassName="w-full"
                error={errors['Email']}
                errorClassName="absolute -mt-6 ml-6 "
                placeholder=""
                customChange={onChange}
              />
            )}
          />

          {alphaData.IsHomeDelivery == true && (
            <>
              <div className="w-full my-4 mb-5 -mt-1 text-sm font-medium text-gray-500 bg-white">
                <Controller
                  name="Address"
                  control={control}
                  defaultValue=""
                  render={({ name, value, onChange }) => (
                    <LocationInput
                      name={name}
                      value={value}
                      className="w-full p-2 mr-1 "
                      id={name}
                      labelClassName="flex ml-2 text-sm text-gray-500 font-medium"
                      label="Delivery Address"
                      wrapperClassName="w-full"
                      error={errors['Address']}
                      placeholder=""
                      customChange={(locationValue: OptionTypeBase) => {
                        setDestination(locationValue?.value.place_id);
                        onChange(locationValue?.label);
                      }}
                    />
                  )}
                />
              </div>
            </>
          )}
        </div>

        <button
          className="w-full py-3 mt-6 text-sm font-medium text-white bg-black rounded"
          type="submit"
        >
          {userState || priceState ? <BeatLoader color="white" /> : 'Proceed'}
        </button>
        <div className="w-full my-6 font-semibold text-center text-red-600">
          <p>{errorMsg}</p>
        </div>
      </div>
    </form>
  );
};
